import React from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';

import { useSelector } from 'react-redux';
import { isAuthenticated } from '../../redux/auth/selectors';

import { AppLayout } from '../Layout';

type Props = RouteProps & {
  title?: string;
  component: any; // TODO - Properly type this. Not sure how this should be typed
};

const PrivateRoute: React.FC<Props> = ({ component: Component, ...rest }) => {
  const authenticated = useSelector(isAuthenticated);

  return (
    <Route
      {...rest}
      render={props =>
        authenticated ? (
          <AppLayout>
            <Component {...props} />
          </AppLayout>
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
};

export default PrivateRoute;
